import React, { Component } from 'react'
import TickBox from './misc/TickBox';
import GreenButton from './misc/GreenButton';
import GreenButtonHeader from './misc/GreenButtonHeader';

export class WelcomeScreen extends Component {
  continue = () => {
    window.location.href = "/quiz"
  }

  render() {
    return (
      <div>
        <div className="header">
          <div className="bar">
            <div>
              <img className="headerLogo" src={require("../assets/imgs/logo.png")} alt="logo" />
              <p style={{ fontSize: '20px', color: 'white' }}>Birth to age 5</p>
            </div>

            <p></p>

            <div>
              <GreenButtonHeader nextStep={this.continue} name="BEGIN TEST" />
              <p style={{ visibility: 'hidden' }}>OK</p>
            </div>
          </div>

        </div>
        {/* <img alt="snake-small" className="white-snake-home" src={require("../../assets/imgs/white-snake-small.png")} /> */}

        {/* <div className="align-center">
          <span className="home-text">DEVELOPMENT TEST</span><br />
          <span className="home-text2">6 Areas Of Development</span>
        </div> */}

        <div className="part2intro">

          <div className="tickboxesBox">
            <TickBox text={"Do you ever wonder if your child is developing up to speed?"} />
          </div>

          <div className="align-center home-margin">
            <span className="home-text">DEVELOPMENT TEST</span><br />
            <img className="six-areas" src={require("../assets/imgs/6areas.png")} alt="6areas" />
          </div>

          <div className="tickboxesBox">
            <TickBox text={"Take our free 6 Areas of Development Test."} />
            <TickBox text={"Get a detailed report of your child's current development status."} />
          </div>
        </div>

        <div className="welcome-end">
          <GreenButton style={{ margin: '20px auto' }} continue={this.continue} name="BEGIN TEST" />
        </div>
      </div>
    )
  }
}

export default WelcomeScreen
